import { useSearchParams, Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { XCircle, AlertCircle, Mail } from 'lucide-react';

export default function ExpiredInvite() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
            <XCircle className="h-8 w-8 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Invitation Expired or Invalid</CardTitle>
          <CardDescription className="text-base">
            This invitation link is no longer valid.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="rounded-lg border border-destructive/20 bg-destructive/5 p-4">
            <div className="flex items-start gap-3">
              <AlertCircle className="h-5 w-5 text-destructive mt-0.5" />
              <div className="space-y-2 text-sm">
                <p className="font-medium">This invitation may have:</p>
                <ul className="list-disc list-inside space-y-1 text-muted-foreground">
                  <li>Expired (invitations are valid for a limited time)</li>
                  <li>Already been used</li>
                  <li>Been cancelled by the workspace administrator</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <p className="text-sm text-muted-foreground text-center">
              Please contact the person who invited you to request a new invitation.
            </p>

            {token && (
              <div className="text-xs text-muted-foreground text-center p-2 bg-muted rounded">
                Invitation token: {token.substring(0, 8)}...
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <Button asChild className="w-full">
              <Link to="/auth">Go to Login</Link>
            </Button>
            <Button asChild variant="outline" className="w-full">
              <a href="mailto:support@billportal.ai">
                <Mail className="mr-2 h-4 w-4" />
                Contact Support
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
